import { z } from "zod/v4";

import { CreateVariationDtoSchema } from "../../../dtos/variations";

export const FileBuildRequestBodySchema = z.object({
  experienceId: z.uuid().nullish(),
  name: z.string(),
  selectedProducts: z.object({ productId: z.string() }).array().default([]),
  variations: CreateVariationDtoSchema.array(),
  forExternalPriceUpload: z.boolean().optional(),
});

export type FileBuildRequestBodyType = z.infer<
  typeof FileBuildRequestBodySchema
>;

export const FileBuildRequestPathParamsSchema = z.object({
  type: z.string(),
});
export type FileBuildRequestPathParamsType = z.infer<
  typeof FileBuildRequestPathParamsSchema
>;

export const FileBuildResponseBodySchema = z.object({
  fileS3Location: z.string().nullish(),
});
export type FileBuildResponseBodyType = z.infer<
  typeof FileBuildResponseBodySchema
>;
